import { H3Event } from 'h3'

export function performanceCheckpoint(event: H3Event, key: string) {
    event.context.performance ||= {}
    event.context.performance[key] ||= []

    // If the array is empty, push the current time
    if (event.context.performance[key].length  < 2) {
        event.context.performance[key].push(process.hrtime()[0] * 1000 + process.hrtime()[1] / 1000000)
        return
    }

    console.warn(`[Performance Measurement]: Attempting to add a third value to the performance array for key '${key}'. This is not allowed.`)
}
